const initialState = {
  showFooter: false
}

const globalReducerHandler = (state = initialState, action) => {
  switch(action.type){
    case "SHOW_FOOTER": {
      return {
        ...state,
        showFooter: action.payload
      }
    }
    default: return state
  }
}

export default globalReducerHandler